import styled from 'styled-components';

export default styled.div`
  display: inline-block;
  height: 4.5rem;
  padding:0 1.5rem;
  line-height: 4.5rem;
  font-size: 1.4rem;

  &:focus {
     outline: none;
     border: 1px solid rgb(168, 174, 207);
     color: rgb(47, 49, 57);
  }

  ${props => props.thisStyles}

`;
